/**
 * pageareatracker-service is an AMD module that returns
 * pageareaTrackerService implementation.
 * Api service.
 *
 * @summary track clicks on page
 * @version 0.1
 * @since 0.1
 * @author Arian Khosravi <arian.khosravi@aofl.com>
 * @module pageareatracker-service
 */

define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function parentApiServiceImpl(aoflModules) {
  'use strict';

  var storeService = aoflModules.store;

  var pageareaTrackerService = function pageareaTrackerService(
    pageareaStateService
  ) {
    storeService.addState(pageareaStateService);

    var PageareaTracker = function PageareaTracker(_tracker) {
      this.tracker = _tracker;
      this.trackFn = this._track.bind(this);
      this.eventPayload = {
        /* eslint-disable */
        // @to-do We need to get the correct event type for each page change
        // and connect with BI team to implement it on their api side.
        event_type: 'com.aofl.readingiq.section.change',
        payload: {}
      }; /* eslint-enable */
    };

    PageareaTracker.prototype = {
      constructor: PageareaTracker,
      init: function init() {
        this.page = [];
        this.pagearea = {nextState: {}};
        this.unsubscribe = storeService.subscribe(this.trackFn);
      },
      deInit: function deInit() {
        this.unsubscribe();
      },
      _track: function _track() {
        var state = storeService.getState();

        if (
          state.pagearea.page.length !== 0 &&
          state.pagearea.page !== this.page
        ) {
          this.page = state.pagearea.page;
          this.tracker.enqueueEvent(
            Object.assign({}, this.eventPayload, {
              payload: {
                page: this.page
              }
            })
          );
        }

        if (
          state.pagearea !== this.pagearea &&
          state.pagearea.nextState.name &&
          state.pagearea.nextState.name !== this.pagearea.nextState.name
        ) {
          this.pagearea = state.pagearea;
          this.tracker.enqueueEvent(
            Object.assign({}, this.eventPayload, {
              payload: {
                from_page: this.pagearea.previousState,
                to_page: this.pagearea.nextState
              }
            })
          );
        }
      }
    };

    return PageareaTracker;
  };

  return pageareaTrackerService;
});
